import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';

export const errorInterceptor: HttpInterceptorFn = (request, next) => {
  const auth = inject(AuthService);
  const notifications = inject(NotificationService);
  const router = inject(Router);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        auth.logout();
        void router.navigate(['/']);
      } else if (error.status === 403) {
        auth.logout();
        void router.navigate(['/']);
      }

      const fallback = error.status >= 500 ? 'Server error. Please try again later.' : 'Something went wrong.';
      notifications.show(error.error?.message ?? fallback);
      return throwError(() => error);
    }),
  );
};
